module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-03responsabilidad-civil.31999069.jpg";